module.exports = __webpack_public_path__ + "static/media/ventania.6d708a55.webp";